import React, { FC } from 'react';

import { Board } from '@/Components/Partials';
import { StationLogFileModel } from '@/entities/Station';

import S from './FileLog.module.scss';

interface FileLogProps {
    fileLog: StationLogFileModel;
}

export const FileLog: FC<FileLogProps> = ({ fileLog }) => {
    return (
        <a target="_blank" href={fileLog.url} className={S.root} rel="noreferrer">
            <Board.Item className={S.root__board_item}>
                <p className={S.root__file_name}>{fileLog.name}</p>
                <p>{fileLog.m_time.toString()}</p>
                <span className={S.root__download}>Download</span>
            </Board.Item>
        </a>
    );
};
